import Icon from "@components/primitives/icon/Icon";

function Socials() {
  return (
    <div className="flex gap-5 flex-wrap items-center">
      <Icon
        className="h-[28px] text-secondary hover:text-primary cursor-pointer transition-all"
        prefix="fab"
        href="https://instagram.com/nextge.neration/"
        icon="instagram"
      />
      <Icon
        className="h-[28px] text-secondary hover:text-primary cursor-pointer transition-all"
        prefix="fab"
        href="https://www.tiktok.com/@nextge.neration"
        icon="tiktok"
      />
      <Icon
        className="h-[28px] text-secondary hover:text-primary cursor-pointer transition-all"
        href="mailto:next@martvanweeghel.nl"
        icon="envelope"
      />
      <Icon
        className="h-[28px] text-secondary hover:text-primary cursor-pointer transition-all"
        prefix="fab"
        href="https://www.youtube.com/@nextge.neration"
        icon="youtube"
      />
      <Icon
        className="h-[28px] text-secondary hover:text-primary cursor-pointer transition-all"
        prefix="fab"
        href="https://open.spotify.com/user/31yabtmvjyuvvcfnudbjuy25trba"
        icon="spotify"
      />
    </div>
  );
}

export default Socials;
